import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 332px;
  margin: 0 auto;

  .RequestTokenModal__Label {
    align-self: flex-start;
    margin: 10px 0 20px 0;
  }

  .RequestTokenModal__SubmitButton {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      border-color: #fff;
      border-top-color: transparent;
      height: 30px;
      width: 30px;
    }
  }
`

export const Title = styled.span`
  line-height: 23px;
`

export const TokenInputWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`

export const TokenInfoContainer = styled.div`
  ul {
    margin-top: 25px;
    li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 15px;
      margin-bottom: 20px;

      div {
        min-height: 30px;
        min-width: 30px;
        background-color: #1F35B5;
        border-radius: 50%;

        display: flex;
        justify-content: center;
        align-items: center;

        span {
          color: #fff;
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
  }
`

export const SpinnerContainer = styled.div`
  background: #2036b5;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  margin-bottom: 10px;
  margin: 0 auto;
  .RequestTokenModal__Spinner {
    height: 27px !important;
    width: 27px !important;
    border-width: 3px !important;
    border-color: #fff !important;
    border-top-color: transparent !important;
  }
`
